
export class ProductionApprovalDetails {
    requirementID:any;
    jobNumber:string;
    rmhName:string;
    rmhId:string;
    requirementType : string;
    jobType:string;
    brand:string;
    crop:string;
    language:string;
    state:string;
    requirementMonth:string;
    requestQuantity : any;
    availableQuantity : any;
    finalQuantity:any;
    poApprovedQty:any;
    wHLocation:any;
    orderStatus:any;
    vendorType:any;
    status:string;
    isActive : boolean;
}

export class ProductionApprovalFilters {
    jobNumbers:jobNumber[];
    rmhs:RMH[];
    jobTypes:JobType[];
    brands:Brand[];
    crops:Crop[];
    languages:Language[];
    status:RequirementStatus[];
    states:State[];
    maMapping:MaMapping[];
    mapping : stateMapping[];
}

export class jobNumber{
    jobNumberID:string;
    jobNumberName:string;
    rMHCode:string;
    brandID: string;
    jobTypeID:number;
    cropID:number;
    languageID:number;
    stateName: string;
    month : string
    statusID : string;
}
export class RMH{
    rMHCode:string;
    rMHName:string;
}

export class Brand{
    brandID:string;
    brandName:string;
}

export class JobType{
    jobTypeID:number;
    jobTypeName:string;
}

export class Crop{
    cropID:number;
    cropName:string;
}

export class Language{
    languageID:number;
    languageName:string;
}

export class RequirementStatus{
    requirementStatusID:number;
    requirementStatusName:string;
}

export class State{
    stateID:string;
    stateName:string;
}

export class MaMapping{
    rMHCode:string;
    stateName:string;
    ma:string;
}

export class stateMapping{
    languageID : number;
    languageName : string;
    state : string;
}

export class updateStatus{
    JobNumber : string;
}